import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'attestation-applicant-card',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {},
  }),
  options
);

export default useStyles;
